// @flow
import React from "react";
import { t } from "ttag";
import { GlobalNavigation, Icon, LanguageSwitcher } from "@2po-c21/components";
import { getSocialIcon } from "../Header";
import style from "./style.module.scss";
import { getInternalOrExternal } from "../../utils/link/link";

type SocialLink = {
    externalLink: string,
    linkTitle: string,
};

type TopBarProps = {
    socialLinks: { nodes: Array<SocialLink> } | Array<SocialLink>,
    topNavigationItems?: Array<{ title: string }>,
    translationSlugs: Array<any>,
    LinkComponent: React$ComponentType<any>,
    locale: string,
};

const renderSocialLink = (item: SocialLink, index: number) => (
    <GlobalNavigation.Socials.Link key={index}>
        <a
            href={item.externalLink}
            title={item.linkTitle}
            className={style.socialLink}
            target="_blank"
            rel="noreferrer"
        >
            <Icon
                icon={getSocialIcon(item.linkTitle)}
                variant="white"
                size="sm"
            />
        </a>
    </GlobalNavigation.Socials.Link>
);

const TopBar = ({
    socialLinks,
    topNavigationItems,
    translationSlugs,
    LinkComponent,
    locale,
}: TopBarProps) => {
    const socialLinksArray = Array.isArray(socialLinks?.nodes)
        ? socialLinks.nodes
        : Array.isArray(socialLinks)
        ? socialLinks
        : [];

    return (
        <GlobalNavigation>
            <GlobalNavigation.Socials title={t`common.text.follow-us`}>
                {socialLinksArray.map(renderSocialLink)}
            </GlobalNavigation.Socials>
            <GlobalNavigation.Container>
                <GlobalNavigation.LinkContainer>
                    {topNavigationItems &&
                        Array.isArray(topNavigationItems) &&
                        topNavigationItems.map((item, index) => (
                            <GlobalNavigation.LinkContainer.Link key={index}>
                                <a
                                    href={getInternalOrExternal(item)}
                                    className={style.topNavigationItem}
                                    title={item.title}
                                >
                                    {item.title}
                                </a>
                            </GlobalNavigation.LinkContainer.Link>
                        ))}
                </GlobalNavigation.LinkContainer>
                <GlobalNavigation.LanguageSwitcher>
                    <LanguageSwitcher
                        locale={locale}
                        title="Langue"
                        options={translationSlugs}
                        LinkComponent={LinkComponent}
                    />
                </GlobalNavigation.LanguageSwitcher>
            </GlobalNavigation.Container>
        </GlobalNavigation>
    );
};

export default TopBar;
